import { ReactNode } from "react";
import styled from "styled-components";

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.3em;

  padding: 0.5em;
`;

const GridPanel = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #979797;

  overflow-y: auto;
  max-height: 250px;

  > span {
    padding: 0.5em;
  }
`;

const AdvancedLookupForm = ({
  inputComponents,
  selections,
}: {
  inputComponents: ReactNode;
  selections: ReactNode | ReactNode[];
}) => {
  return (
    <Grid>
      {inputComponents}
      <GridPanel>{selections}</GridPanel>
    </Grid>
  );
};

export default AdvancedLookupForm;
